/**
 * Authors: mariushirjanu
 * Created: 05/08/2021
 */
import { util } from '../../util';
import { Injectable } from '@angular/core';
import { FormattingService } from '../../services/formatting.service';
import { ICountryExtended, ILocationExtended } from '../../../../type_definitions/datatypes';

@Injectable()
export class InvoiceTemplatesFormattingService {

  constructor(
    private formattingService:FormattingService
  ) {
    /***/
  }

  public formatLocation = (location:ILocationExtended):string => {
    if (!location) {
      return;
    }

    return this.formattingService.formatLocationHtml(location, {
      name: (<ICountryExtended>location.country)?.vatName || 'VAT/TAX',
      number: location.vatNumber
    });
  };

  public formatLocationL = (location) => {
    if (!location) {
      return undefined;
    }

    return this.formattingService.join(
      location.companyRegisteredName,
      location.vatNumber? 'VAT/TAX ' + location.vatNumber : undefined,
      this.formattingService.formatLocation(location, '<br />'),
      '<br />'
    );
  };

  public formatLocationS = (location):string => {
    return this.formattingService.formatLocation(location, ', ');
  };

  public formatPct = (pct:number):string => {
    if (util.isNullOrUndefinedOrEmpty(pct)) {
      return '';
    }
    return this.formattingService.formatNumber(pct) + ' %';
  };
}
